import { render, staticRenderFns } from "./NewEmail.vue?vue&type=template&id=29477e54&"
import script from "./NewEmail.vue?vue&type=script&lang=js&"
export * from "./NewEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports